import React from 'react'
import PermissionHOC from 'components/Permissions/PermissionHOC'
import { Badge } from 'components/Form'
import { WrapSideBarItem, SelectedSideBarItem } from './Styled'

const SideBar = (props) => {
    const { loading, disabled, hideBorder, feature, selected, label, action, subItem, badge } = props

    return (
        <WrapSideBarItem
            disabled={feature?.disabled || disabled}
            onClick={() => action(props)}
            $subItem={subItem}
            variant={"text"}
            $selected={selected}
            color={selected ? 'secondary' : 'white'}
        >
            <SelectedSideBarItem $selected={selected} $hideBorder={hideBorder} />
            <div className='item-content'>
                <div className='item-label-and-icon'>
                    <div className='sub-item-icon'>
                        {!subItem && <props.icon sx={{ fill: "red" }} fontSize={"18"} />}
                    </div>
                    <div className='sub-item-label'>
                        {label}
                    </div>
                </div>
                {!badge || <Badge active value={badge} />}
            </div>
        </WrapSideBarItem>
    )
}

export default PermissionHOC(SideBar)